/**
 * Site-level constants and small helpers.
 *
 * Anywhere a route, copy block, or SEO file refers to "the site URL" or
 * "the company", it should pull from here so the answer stays consistent
 * across every surface (sitemap, JSON-LD, OG tags, llms.txt, footer).
 */

import { env as publicEnv } from '$env/dynamic/public';

/** Production canonical origin. The single source of truth. */
export const SITE_URL_PROD = 'https://ekavi.care';

/** Resolve the runtime origin. */
export function siteUrl(): string {
	const fromEnv = publicEnv.PUBLIC_SITE_URL;
	if (fromEnv && fromEnv.length > 0) {
		// strip trailing slash to keep concatenation predictable
		return fromEnv.replace(/\/$/, '');
	}
	return SITE_URL_PROD;
}

/** Produce an absolute URL from a path (`/trust/`, `/notes/foo/`, …). */
export function absoluteUrl(path: string): string {
	const base = siteUrl();
	if (!path.startsWith('/')) return `${base}/${path}`;
	return `${base}${path}`;
}

export const SITE = {
	name: 'Ekavi Care',
	domain: 'ekavi.care',
	tagline: 'An AI back-office colleague for independent practices.',
	description:
		'Ekavi Care is an AI back-office colleague for small US ambulatory practices. It runs the back office as one — across the EHR you already use, the clearinghouse you trust, the scribe you bought, and the agentic AI we built for the rest. Prior auth and eligibility, claims and denials, charge capture and coding, scheduling and the AI receptionist, EHR management. Recruiting five founding design partners.',
	publisher: {
		name: 'Ekavi Care',
		legalName: 'Ekavi Care',
		url: 'https://ekavi.care'
	},
	contact: {
		applyEmail: 'apply@ekavi.care',
		trustEmail: 'trust@ekavi.care',
		privacyEmail: 'privacy@ekavi.care'
	},
	social: {
		// No social presence to publish at v0.1. Adding entries here
		// surfaces them in JSON-LD `sameAs` and the footer.
	}
} as const;
